export default __webpack_public_path__ + "static/media/cerebro.7434e814.gif";